import React, { useState, useEffect } from 'react';
import {
    DataTable,
    TableContainer,
    Table,
    TableHead,
    TableRow,
    TableExpandHeader,
    TableExpandRow,
    TableExpandedRow,
    TableHeader,
    TableBody,
    TableCell,
    TableToolbar,
    TableToolbarContent,
    TableToolbarMenu,
    TableToolbarSearch,
    Button,
    Checkbox,
    TooltipDefinition
} from 'carbon-components-react';
import { Link } from "react-router-dom";
import QueueDetails from '../QueueDetails';
import { LinearGauge } from 'components/LinearGauge/LinearGauge';
import TableToolbarDownload from 'common/TableToolbarDownload';
import Filters from './Filters';
import { Modal } from 'carbon-components-react';
import {
    FilterEdit32, CircleFilled24, DotMark32, CheckmarkFilled20 as Resolved, InformationFilled20 as New, CloseFilled20 as Cancelled,
    StopFilled20 as Closed, WarningFilled20 as OnHold, PendingFilled20 as InProgress, NextFilled20 as InQueue, ErrorFilled20 as Rejected,
    RecordingFilled20 as Open, UserAvatarFilled20 as Assigned
} from '@carbon/icons-react';
// import Cancelled from 'assets/image/Cancelled.svg'
// import New from 'assets/image/New.svg'
// import Closed from 'assets/image/Closed.svg'
// import InProgress from 'assets/image/InProgress.svg'
// import OnHold from 'assets/image/OnHold.svg'
// import Resolved from 'assets/image/Resolved.svg'
import QueryQueue from 'assets/image/QueryQueue.svg';
import i18n from "../../../i18n";
import * as Constants from '../../../requests/URLConstants'
import callPostApi from "../../../requests/PostRequests";
import { customSortRow, defaultSortRow } from "./SortingUtility";
import moment from 'moment';
import DigitalWorkerTaskDetails from '../DigitalWorkerTaskDetails';
import { NewTab16 } from '@carbon/icons-react';
import qs from 'query-string';
import { useLocation } from 'react-router';
import * as configConst from "../../../config/Constants";
import * as workspaces from '../../../config/WorkspaceConstants'


require("../_queue-details.scss");

const AlertsTable = props => {
    //console.log(props.rows);
    const [showFilters, setShowFilters] = useState(false);
    const [loader, setLoader] = useState(false);
    const [showQueueDetailsModal, setShowQueueDetailsModal] = useState(false);
    const [queueData, setQueueData] = useState();
    const [expandedQueueData, setExpandedQueueData] = useState([]);
    const [digitalWorkerData, setDigitalWorkerData] = useState();
    const [showDigitslTaskDetailsModal, setShowDigitslTaskDetailsModal] = useState(false);
    const [showTaskDetailsButton, setShowTaskDetailsButton] = useState(false);
    const location = useLocation();



    // const [responseSLA,setResponseSLA] = useState(props.SLAresponseData);
    const [sysId, setSysId] = useState('');
    const openQueueDetailsModal = () => {
        setShowQueueDetailsModal(true);
    }
    const closeQueueDetailsModal = () => {
        setShowQueueDetailsModal(false);
    }

    const openDigitslTaskDetailsModal = () => {
        setShowDigitslTaskDetailsModal(true);
    }
    const closeDigitslTaskDetailsModal = () => {
        setShowDigitslTaskDetailsModal(false);
    }

    const viewQueueDetails = i18n.t('manageAutomation.QueueDetails');
    const filters = i18n.t('manageAutomation.filters');

    //console.log("PROPSALERT", props);

    useEffect(() => {
    }, [queueData, digitalWorkerData]);

    // useEffect(() => {
    //     console.log("TableSLA" + props.SLAresponseData);
    //     console.log("linearGauge"+ props.SLAresponseData);
    //    props.SLAresponseData && setResponseSLA(props.SLAresponseData);
    // }, [props.SLAresponseData,responseSLA]);

    const getRowDescription = (rowId) => {
        const row = props.rows.find(({ id }) => id === rowId);
        if (row && row.technology === "Digital Worker (CoE)") {
            setShowTaskDetailsButton(true);
        } else {
            setShowTaskDetailsButton(false);
        }
        if (props.alertType === 'reactive' || props.alertType === 'sapone' || props.alertType === 'Infra-alert-automation' || props.alertType === 'Informational-automation') {
            return row ? row.errorInfo : '';
        } else {
            if (props.workspace === workspaces.automation_ops) {
                let rowDesc = "Impacted Automata(s): ";
                if (row && row.impact && row.impact.length > 0) {
                    row.impact.forEach(function (impact) {
                        rowDesc = rowDesc + impact.automata_name + ", ";
                    });
                    // return rowDesc.substring(0, rowDesc.length - 2);
                    return rowDesc;

                } else {
                    return '';
                }
            } else {
                return row ? row.errorInfo : '';
            }
        }
    };

    const getRowJobId = (rowId) => {
        const row = props.rows.find(({ id }) => id === rowId);
        if (row) {
          return row ? row.job_id.toString() : '';
            }
        
    };


    const hasQueue = (rowId) => {
        const row = props.rows.find(({ id }) => id === rowId);
        if (props.alertType === 'reactive') {
            return row ? row.hasaqueue : false;
        }
    };

    function getUniqueKey(queueDetails,row) {
        console.log(expandedQueueData);
        const found = expandedQueueData.some(el => el.key === row.job_id.toString());
        if (!found) {
            setExpandedQueueData([...expandedQueueData, queueDetails]);
        }
    }

    const getQueueDetails = (selectedRow) => {
        if (!selectedRow.isExpanded) {
            setLoader(true);
            console.log("selectedRow", selectedRow);
            console.log("comparedRow", props.rows);
            const row = props.rows.find(({ id }) => id === selectedRow.id);
            console.log("Filter row", row);

            if (props.workspace === workspaces.automation_ops && row) {
                const bodyQueue = {
                    "jobid": row.job_id,
                    "app_host_machine_nm": row.app_host_machine_nm,
                }
                // const bodyQueue = {
                //     "jobid": "46744E4C-5F7A-4F8A-A86B-798D4148AD52",
                //     "app_host_machine_nm": "よくやったlogstash-stg-3-machineようこそ"
                // }
                callPostApi(Constants.GETQUEUEDATA, {
                    'Content-Type': 'application/json'
                }, bodyQueue)
                    .then(result => {
                        //console.log(result);
                        setLoader(false)
                        // setQueueResponse({
                        //   loadingQueueData: false,
                        //   queueData: result,
                        // });
                        if (result) {
                            setQueueData(result);
                            if (result?.aggregations?.summary?.buckets?.length > 0) {
                                let queueDetails = result?.aggregations?.summary?.buckets[0];
                                if (expandedQueueData?.length > 0){
                                    getUniqueKey(queueDetails,row)
                                }
                                else
                                setExpandedQueueData([queueDetails]);
                            }
                        }
                    })
                    .catch((error) => {
                        setLoader(false);
                        console.error('Error:', error);
                    });
            }

            if (props.workspace === workspaces.automation_ops && row && row.technology === "Digital Worker (CoE)") {
                const bodytask = {
                    "job_id": row.job_id,
                    "technology": row.technology,
                }

                // "technology": "Digital Worker (CoE)",

                // const bodytask = {
                //     "job_id": "57b5ed3d41203238",
                //     "technology": "Digital Worker (CoE)",
                // }
                callPostApi(Constants.GETDIGITALWORKERTASKDETAILS, {
                    'Content-Type': 'application/json'
                }, bodytask)
                    .then(result => {
                        //console.log(result);
                        setLoader(false);
                        if (result) {
                            setDigitalWorkerData(result);
                        }


                    })
                    .catch((error) => {
                        setLoader(false);
                        console.error('Error:', error);
                    });
            }
        }
        // if (selectedRow.isExpanded) {
        //     let newArr = [];
        //     if (expandedQueueData.length > 0) {
        //         expandedQueueData.map((item) => {
        //             if (item.key === selectedRow.id.toString()) {
        //                 newArr = expandedQueueData.filter(item => item.key !== selectedRow.id.toString());
        //                 setExpandedQueueData(newArr);
        //             }
        //         })
        //     }
        // }
    };

    const handleFilters = () => {
        setShowFilters(!showFilters);
    };
    const handleClose = () => {
        setShowFilters(!showFilters);
    }

    const manageHeader = (checked, id, event) => {
        var h = [...props.headers];
        h.forEach(function (header) {
            if (header.key === id) {
                header.hidden = !checked;
            }
        });
        if (props.alertType === 'reactive' && props.status !== 'IncidentsUser' && props.status !== 'IncidentsBuisness' && props.status !== 'SystemRecommendations') {
            if (props.status === 'Running') {
                props.updateState('runningAlertHeaders', h, 'Alert');
            }
            else props.updateState('alertHeaders', h, 'Alert');
        } else if (props.alertType === 'reactive' && props.status === 'IncidentsUser') {
            props.updateState('alertHeaders', h, 'UserAlert');
        } else if (props.alertType === 'reactive' && props.status === 'IncidentsBuisness') {
            props.updateState('alertHeaders', h, 'UserBuisness');
        } else if (props.alertType === 'sapone' && props.status === 'SystemRecommendations') {
            props.updateState('alertHeaders', h, 'SystemRecommendations');
        }
        else {
            if (props.alertType === 'SecurityAlert' && props.status === 'SecurityAlert') {
                props.updateState('alertHeaders', h, "SecurityAlert")
            }else if (props.alertType === 'Infra-alert-automation' && props.status === 'Exception') {
                props.updateState('alertHeaders', h, "Infra-alert-automation")
            }else if (props.alertType === 'Informational-automation' && props.status === 'Informational') {
                props.updateState('alertHeaders', h, "Informational-automation")
            }
            else props.updateState('alertHeaders', h, "PredictedAlert");

        }
    };

    const openTicketingTool = (url) => {
        window.open(url, "_blank");
    };

    const determineVeracity = (veracity) => {
        if (veracity >= 0 && veracity <= 25 && veracity !== null) {
            //red
            return '#FA4D56';
        }
        else if (veracity > 25 && veracity <= 75) {
            //yellow
            return "#F1C21B";
        }
        else if (veracity > 75 && veracity <= 100) {
            //green
            return "#6FDC8C";
        }
        else return "#C6C6C6";
    }

    const displayCell = (cell, currentRow) => {
        // let linearGaugeData = props.SLAresponseData.length>0?props.SLAresponseData:[];
        let currentHeader = props.headers.filter(function (header) { return header.key === cell.info.header });
        // let alertType = props.alertType === 'reactive' ? 'alert' : 'palert';
        // let path = '/IncidentDetails/' + alertType + "/";
        // console.log("currentRow",cell);
        // let alertType = props.alertType === 'reactive' ? 'alert' : 'palert';
        let alertType = props.alertType === 'reactive' ? 'alert' : props.alertType;

        // let path = '/IncidentDetails/' + alertType + "/";
        let path = '/IncidentDetails';

        //console.log("currentRow", cell);
        if (displayHeader(currentHeader[0])) {
            switch (cell.info.header) {
                case "incidentId":
                    let sysId;
                    sysId = (currentRow.cells).find(cell => cell.info.header === "sysId");
                    sysId = sysId ? sysId.value : '';
                    if (sysId === '' || sysId === undefined) {
                        sysId = cell.value ? cell.value.substr(cell.value.indexOf("/") + 1) : "";
                    }
                    // let sysId = cell.value ? cell.value.substr(cell.value.indexOf("/") + 1) : "";
                    let incidentId = cell.value ? cell.value.substr(0, cell.value.indexOf("/")) : "";
                    // path = path + sysId;
                    let ticketingToolPath = (currentRow.cells).find(cell => cell.info.header === "incidentURL");
                    

                    let veracity = (currentRow.cells).find(cell => cell.info.header === "veracity");
                    let veracityValue = veracity && veracity !== undefined && veracity !== null && veracity.value ? (Math.round(veracity.value.replace('%', '') * 100) / 100) : null;
                    let fillColor = determineVeracity(veracityValue);


                    let client = (currentRow.cells).find(cell => cell.info.header === "client");
                    client = client ? client.value : '';
                    let applicationName = (currentRow.cells).find(cell => cell.info.header === "source provider");
                    applicationName = applicationName ? applicationName.value : '';
                    let createdAt = (currentRow.cells).find(cell => cell.info.header === "createdAt");
                    createdAt = createdAt && createdAt.value !== '-' ? moment(createdAt.value).toISOString() : '';

                    /* Query Parameters */
                    const queryParam = qs.parse(location.search);
                    let newQueryParam = {};
                    if (hasQueue(currentRow.id)) {
                        newQueryParam = {
                            ...queryParam,
                            sysId: sysId,
                            alertType: alertType,
                            incidentId: incidentId,
                            workspace: props.workspace,
                            client: client,
                            applicationName: applicationName,
                            createdAt: createdAt,
                            incidentQueue: true
                        }
                    }
                    else{
                        newQueryParam = {
                            ...queryParam,
                            sysId: sysId,
                            alertType: alertType,
                            incidentId: incidentId,
                            workspace: props.workspace,
                            client: client,
                            applicationName: applicationName,
                            createdAt: createdAt,
                        }
                    }

                    /* Query Parameters */

                    if (incidentId !== "NA" && props.status !== 'IncidentsUser') {
                        // return <TableCell key={cell.id}><Link className="remove-underline" to={path}>{incidentId}</Link></TableCell>
                        return (
                            <TableCell key={cell.id}>
                                <div className="incident-link">
                                    <Link className="remove-underline"
                                        to={
                                            {
                                                pathname: path, search: qs.stringify(newQueryParam)
                                                // ,selectedEntity: currentRow.cells[8] ? currentRow.cells[8].value : '',
                                                // aiopsInfo: currentRow.cells[14] ? currentRow.cells[14].value : '',
                                                // workspace: props.workspace, client: currentRow.cells[12] ? currentRow.cells[12].value : '',
                                                // franchise: currentRow.cells[13] ? currentRow.cells[13].value : '', technology: currentRow.cells[16] ? currentRow.cells[16].value : '',
                                                // ticketingToolPath: ticketingToolPath, incidentdetail: { currentRow }, incidentId: incidentId
                                            }
                                        }>
                                        <div className="incident-id">{incidentId}</div>
                                    </Link>
                                    {ticketingToolPath &&
                                        <Button
                                            className="buttonIcon"
                                            hasIconOnly
                                            tooltipAlignment="center"
                                            tooltipPosition="bottom"
                                            iconDescription="open in new tab"
                                            renderIcon={NewTab16}
                                            kind='ghost'
                                            onClick={() => openTicketingTool(ticketingToolPath.value)}
                                        />
                                    }
                                    {props.status === 'Ticketed' && props.alertType === 'reactive' ? <div className='veracity-container'>
                                        <TooltipDefinition
                                            tooltipText={<div>
                                                <div className='title'>Alert Reversal Probability</div>
                                                {veracityValue !== null ?
                                                    <div className='score'>There is <span className='percentage'>{veracityValue}%</span> chance of this incident being auto resolved.</div> :
                                                    <div className='score'>Alert reversal flow is not enabled.</div>}
                                            </div>}
                                            direction="right"
                                            alignment="left">
                                            <DotMark32 style={{ fill: fillColor }} />
                                        </TooltipDefinition>
                                    </div> : null}
                                </div>
                            </TableCell>
                        )
                    } else if (incidentId !== "NA" && props.status === 'IncidentsUser') {
                        // let incidentsUserDetailsPath = '/UserIncidentDetails/' + alertType + "/";
                        let incidentsUserDetailsPath = '/UserIncidentDetails';
                        // incidentsUserDetailsPath = incidentsUserDetailsPath + sysId;
                        return <TableCell key={cell.id}>
                            <div className="incident-link">
                                <Link className="remove-underline"
                                    to={{
                                        pathname: incidentsUserDetailsPath, search: qs.stringify(newQueryParam)
                                        // ticketingToolPath: ticketingToolPath,
                                        // workspace: props.workspace, client: currentRow.cells[8] ? currentRow.cells[8].value : '', incidentdetail: { currentRow }, incidentId: incidentId
                                    }}>
                                    <div className="incident-id">{incidentId}</div>
                                </Link>
                                {ticketingToolPath &&
                                    <Button
                                        className="buttonIcon"
                                        hasIconOnly
                                        tooltipAlignment="center"
                                        tooltipPosition="bottom"
                                        iconDescription="open in new tab"
                                        renderIcon={NewTab16}
                                        kind='ghost'
                                        onClick={() => openTicketingTool(ticketingToolPath.value)}
                                    />
                                }
                            </div>
                        </TableCell>
                    } else {
                        return <TableCell key={cell.id}>{incidentId}</TableCell>
                    }
                case "SLA_due_in":
                    //console.log(cell);
                    let sysIdNew = cell.value ? cell.value.substr(cell.value.indexOf("/") + 1) : "";
                    let incidentIdNew = cell.value ? cell.value.substr(0, cell.value.indexOf("/")) : "";
                    let businessPercentage = cell.value ? cell.value.substr(cell.value.indexOf("/") + 1) : "";
                    let businessTimeLeft = cell.value ? cell.value.substr(0, cell.value.indexOf('/')) : "";
                    path = path + sysIdNew;
                    if (businessPercentage !== "") {
                        return <TableCell className="linear-gauge" key={cell.id}><LinearGauge length={props.rows.length} businessTimeLeft={businessTimeLeft} SLAresponseData={businessPercentage} /></TableCell>
                    } else {
                    }
                case "incident_status":
                case "incidentStatus":  //added both spellings for same case.
                    switch (cell.value) {
                        case "New":
                            return <TableCell key={cell.id}><div className='img--status'><div><New /></div><div>{cell.value}</div></div></TableCell>
                        case "Cancelled":
                        case "Canceled": //added both spellings for same case.
                            return <TableCell key={cell.id}><div className='img--status'><div><Cancelled /></div><div>{cell.value}</div></div></TableCell>
                        case "On Hold":
                            return <TableCell key={cell.id}><div className='img--status'><div><OnHold /></div><div>{cell.value}</div></div></TableCell>
                        case "In Progress":
                            return <TableCell key={cell.id}><div className='img--status'><div><InProgress /></div><div>{cell.value}</div></div></TableCell>
                        case "Resolved":
                            return <TableCell key={cell.id}><div className='img--status'><div><Resolved /></div><div>{cell.value}</div></div></TableCell>
                        case "Closed":
                            return <TableCell key={cell.id}><div className='img--status'><div><Closed /></div><div>{cell.value}</div></div></TableCell>
                        case "In Queue":
                            return <TableCell key={cell.id}><div className='img--status'><div><InQueue /></div><div>{cell.value}</div></div></TableCell>
                        case "Rejected":
                            return <TableCell key={cell.id}><div className='img--status'><div><Rejected /></div><div>{cell.value}</div></div></TableCell>
                        case "Open":
                            return <TableCell key={cell.id}><div className='img--status'><div><Open /></div><div>{cell.value}</div></div></TableCell>
                        case "Assigned":
                            return <TableCell key={cell.id}><div className='img--status'><div><Assigned /></div><div>{cell.value}</div></div></TableCell>
                        default:
                            return <TableCell key={cell.id}>{cell.value}</TableCell>
                    }
                case "instanceStatus":
                    switch (cell.value) {
                        case "running":
                            return <TableCell className="instance-status" key={cell.id}>
                                <span className="green-indicator">
                                    <CircleFilled24 />
                                </span>
                            </TableCell>
                        case "stopping":
                            return <TableCell className="instance-status" key={cell.id}>
                                <span className="red-indicator">
                                    <CircleFilled24 />
                                </span>
                            </TableCell>
                        default:
                            return <TableCell className="instance-status" key={cell.id}>
                                <span className="default-indicator">
                                    <CircleFilled24 />
                                </span>
                            </TableCell>
                    }
                case "sessionNo":
                    if (hasQueue(currentRow.id)) {
                        return <TableCell key={cell.id}><div className='queue-status'><div><img className='queue-img' src={QueryQueue} /></div><div className="queue-text">{cell.value}</div></div></TableCell>
                    }
                default:
                    return <TableCell key={cell.id}>{cell.value}</TableCell>
            }
        }
        else {
            return null;
        }
    }

    const displayHeader = (header) => {
        const incidentHeaders = ["incidentId", "assigned_to", "incident_status", "incidentStatus"];
        const nonAutomataAnomalies = ["Dependency failure", "Infra Alert", "Log Anomaly","SecurityAlert","Infra-alert-automation", "Informational-automation"];
        if (!['Exception', 'Ticketed', 'All', 'IncidentsUser', 'IncidentsBuisness', 'SystemRecommendations','SecurityAlert'].includes(props.status) && incidentHeaders.includes(header.key)) {
            return false;
        } else {
            if (props.alertType === 'reactive' || props.alertType === 'sapone') {
                return header.hidden ? false : true;
            } else if (nonAutomataAnomalies.includes(props.alertType)) {
                return header.type === 'automata' || header.hidden ? false : true;
            } 
            // else if (props.alertType === 'Infra-alert-automation') {
            //     return header.hidden ? false : true;
            // }
            else {
                return header.type === 'dependency' || header.hidden ? false : true;
            }
        }
    }

    var dateAndTime = moment().format("DD-MM-YYYY HH.mm.ss")

    const fileName = i18n.t('manageAutomation.Alerts') + "_" + i18n.t('manageAutomation.'+props.status) + "-" + String(dateAndTime);

    return (
        <>
            <div className="queue-details-container">
                <Modal
                    passiveModal
                    open={showQueueDetailsModal}
                    size="md"
                    modalHeading="Queue details"
                    onRequestClose={closeQueueDetailsModal}
                >
                    <QueueDetails queueData={queueData} workspace={props.workspace}/>
                </Modal>
            </div>
            <div className="queue-details-container">
                <Modal
                    passiveModal
                    open={showDigitslTaskDetailsModal}
                    size="md"
                    modalHeading="Task details"
                    onRequestClose={closeDigitslTaskDetailsModal}
                >
                    <DigitalWorkerTaskDetails digitalWorkerData={digitalWorkerData} />
                </Modal>
            </div>
            <DataTable
                style={{ padding: 0 }}
                rows={props.rows}
                headers={props.headers}
                SLAresponseData={props.SLAresponseData}
                sortRow={(cellA, cellB, sortDirection, sortStates) => sortDirection.key === "SLA_due_in" ? customSortRow(cellA, cellB, sortDirection, sortStates, props.headers) : defaultSortRow(cellA, cellB, sortDirection, sortStates)}
                isSortable
                render={({
                    rows,
                    headers,
                    getHeaderProps,
                    getRowProps,
                    getTableProps,
                    getToolbarProps,
                    onInputChange,
                    getTableContainerProps,
                }) => (
                    <TableContainer {...getTableContainerProps}>
                        <TableToolbar {...getToolbarProps} aria-label="data table toolbar">
                            <TableToolbarContent style={{ clipPath: 'none', zIndex: 1 }}>
                                <TableToolbarSearch onChange={props.onSearch ? (event) => props.onSearch(event, props.alertType) : onInputChange} />
                                <TableToolbarMenu light iconDescription='Headers'>
                                    <fieldset className="optional-headers">
                                        {/* <legend className={'${prefix}--label'}>
                        Optional Headers</legend> */}
                                        {headers.map(header => (
                                            header.optional ?
                                                <Checkbox labelText={header.header} checked={!header.hidden} onChange={manageHeader} id={header.key} />
                                                : null
                                        ))}
                                    </fieldset>
                                </TableToolbarMenu>
                                <TableToolbarDownload iconDescription='Export' rows={props.fullRows} headers={props.headers} title="Alerts" filename={fileName} label="Download" />
                                {configConst.URL.includes(configConst.unilever) ?
                                    !props.RCAFlag && props.alertType === "reactive" ? <Button iconDescription='Filters' onClick={handleFilters} renderIcon={FilterEdit32}>{filters}</Button> : '' : !props.RCAFlag ? <Button iconDescription='Filters' onClick={handleFilters} renderIcon={FilterEdit32}>{filters}</Button> : ''}
                            </TableToolbarContent>
                        </TableToolbar>
                        {showFilters ?
                            <div><Filters workspace={props.workspace} alertType={props.alertType} filterData={props.filterData} filterSelections={props.filterSelections} status={props.status}
                                disabledSelects={props.disabledSelects} handleClose={handleClose} fetchAlertsData={props.fetchAlertsData} updateState={props.updateState} isResourceType={false} isQueueType={false} /> </div> : null}
                        <Table {...getTableProps()}>
                            <TableHead>
                                <TableRow>
                                    <TableExpandHeader />
                                    {headers.map(header => (

                                        displayHeader(header) ?
                                            <TableHeader
                                                {...getHeaderProps({ header })}
                                            >
                                                {header.header}
                                            </TableHeader> : null

                                    ))}
                                    <TableHeader />
                                </TableRow>
                            </TableHead>
                            {!props.RCAFlag ? <TableBody>
                                {rows.map(row => (
                                    <React.Fragment key={row.id}>
                                        <TableExpandRow className="carbon-display-Regular-14" {...getRowProps({ row })} onClick={() => { getQueueDetails(row) }}>
                                            {row.cells.map(cell => (
                                                displayCell(cell, row)
                                            ))}
                                        </TableExpandRow>
                                        {row.isExpanded && (
                                            <TableExpandedRow className="carbon-display-Regular-14" colSpan={headers.length + 1}>
                                                {/* <p>{getRowDescription(row.id)}</p> */}
                                                {props.workspace === workspaces.automation_ops ?
                                                    loader ?
                                                        <div>{i18n.t('manageAutomation.loading')}</div>
                                                        :
                                                        <div>
                                                            <div className="error-desc carbon-display-Regular-14">
                                                                <div className="error-msg">{getRowDescription(row.id)}</div>
                                                                {expandedQueueData.length > 0 ?
                                                                    expandedQueueData.map((queueItem) => {
                                                                        return queueItem.key === getRowJobId(row.id) &&
                                                                            <div style={{ width: '35%' }}>
                                                                                <div className="error-queue">
                                                                                    <div className="key-value-queue">
                                                                                        <div className="key">{i18n.t('manageAutomation.Noofqueue')}</div>
                                                                                        {queueItem && queueItem.queuetotal ?
                                                                                            <div className="value">{queueItem.queuetotal.value}</div>
                                                                                            : <div className="value">{i18n.t('analytics.NoDataAvailable')}</div>}
                                                                                    </div>
                                                                                    <div className="key-value-queue">
                                                                                        <div className="key">{i18n.t('analytics.Completed')}</div>
                                                                                        {queueItem && queueItem.completed ?
                                                                                            <div className="value">{queueItem.completed.value}</div>
                                                                                            : <div className="value">{i18n.t('analytics.NoDataAvailable')}</div>}
                                                                                    </div>
                                                                                    <div className="key-value-queue">
                                                                                        <div className="key">{i18n.t('analytics.Pending')}</div>
                                                                                        {queueItem && queueItem.pending ?
                                                                                            <div className="value">{queueItem.pending.value}</div>
                                                                                            : <div className="value">{i18n.t('analytics.NoDataAvailable')}</div>}
                                                                                    </div>
                                                                                    <div className="key-value-queue">
                                                                                        <div className="key">{i18n.t('analytics.Running')}</div>
                                                                                        {queueItem && queueItem.running ?
                                                                                            <div className="value">{queueItem.running.value}</div>
                                                                                            : <div className="value">{i18n.t('analytics.NoDataAvailable')}</div>}
                                                                                    </div>
                                                                                    <div className="key-value-queue">
                                                                                        <div className="key">{i18n.t('analytics.Exception')}</div>
                                                                                        {queueItem && queueItem.exception ?
                                                                                            <div className="value">{queueItem.exception.value}</div>
                                                                                            : <div className="value">{i18n.t('analytics.NoDataAvailable')}</div>}
                                                                                    </div>
                                                                                </div>
                                                                                <div>
                                                                                    {queueItem && expandedQueueData.length > 0 ?
                                                                                        <Button className="queue-details-button" kind='tertiary' onClick={openQueueDetailsModal}>{viewQueueDetails}
                                                                                        </Button> : null}
                                                                                </div>
                                                                            </div>

                                                                    })
                                                                    : null}
                                                            </div>
                                                            {showTaskDetailsButton ?
                                                                <Button className="queue-details-button" kind='tertiary' onClick={openDigitslTaskDetailsModal}>{i18n.t('manageAutomation.ViewTaskDetails')}
                                                                </Button>
                                                                : null}
                                                        </div>
                                                    : <div><p>{getRowDescription(row.id)}</p></div>}
                                            </TableExpandedRow>
                                        )}
                                    </React.Fragment>
                                ))}
                            </TableBody> : <TableBody>
                                {rows.map((row) => (
                                    <TableRow className="carbon-display-Regular-14" key={row.id}>
                                        {row.cells.map((cell) => (
                                            displayCell(cell)
                                        ))}
                                    </TableRow>
                                ))}
                            </TableBody>}
                        </Table>
                    </TableContainer>
                )}
            />
        </>
    );
}




export default AlertsTable;
